module.exports = __webpack_public_path__ + "static/gallery-4-4551fd6bba34d2412a7318d7566269ae.jpg";